import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Camila Rodrigues',
    role: 'Professora, 34 anos',
    text: 'Foi a melhor decisão que tomei! O atendimento é extremamente cuidadoso, me senti acolhida desde o primeiro contato. O resultado da harmonização facial ficou absolutamente natural, exatamente o que eu queria.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=smiling%20brazilian%20woman%2034%20years%20old%20natural%20beautiful%20warm%20skin%20confident%20relaxed%20portrait%20soft%20lighting%20neutral%20background%20professional%20photo%20aesthetic%20clinic%20patient%20happy%20Santo%20Andre&width=200&height=200&seq=tes001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Fernanda Lima',
    role: 'Empresária, 41 anos',
    text: 'A MG+ Saúde & Estética é referência em tratamentos estéticos no Centro de Santo André. Profissionalismo, segurança e resultados impecáveis. Já indiquei para várias amigas e todas adoraram!',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=confident%20brazilian%20businesswoman%2041%20years%20natural%20mature%20beauty%20elegant%20portrait%20soft%20warm%20lighting%20neutral%20tones%20happy%20smile%20aesthetic%20treatment%20patient&width=200&height=200&seq=tes002&orientation=squarish',
  },
  {
    id: 3,
    name: 'Juliana Santos',
    role: 'Nutricionista, 29 anos',
    text: 'Fiz a limpeza de pele profunda e o resultado foi incrível! A equipe explica cada etapa com muita paciência e atenção. O ambiente é lindo, limpo e me deixou totalmente à vontade. Voltarei com certeza!',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=young%20brazilian%20woman%2029%20years%20radiant%20skin%20natural%20beauty%20soft%20smile%20warm%20light%20portrait%20wellness%20spa%20aesthetic%20clinic%20happy%20patient%20Santo%20Andre%20SP&width=200&height=200&seq=tes003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Patrícia Moreira',
    role: 'Advogada, 38 anos',
    text: 'Excelência em tudo! Os bioestimuladores de colágeno transformaram minha pele. O tratamento foi seguro, indolor e o pós-atendimento é muito cuidadoso. Me sinto muito mais confiante.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20professional%20brazilian%20woman%2038%20years%20confident%20natural%20beauty%20warm%20tones%20soft%20portrait%20neutral%20background%20polished%20appearance%20happy%20smile&width=200&height=200&seq=tes004&orientation=squarish',
  },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="depoimentos" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#C4A45A] text-xs tracking-[0.35em] uppercase font-raleway block mb-3">
            O que dizem sobre nós
          </span>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#2C2B29] font-light mb-4">
            Depoimentos
          </h2>
          <p className="font-raleway text-[#8B8680] text-sm max-w-xl mx-auto">
            Histórias reais de pacientes que transformaram sua autoestima com a MG+ Saúde &amp; Estética.
          </p>
          <div className="w-12 h-px bg-[#C4A45A] mx-auto mt-6" />
        </div>

        {/* Desktop: All visible */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((t) => (
            <TestimonialCard key={t.id} t={t} />
          ))}
        </div>

        {/* Mobile: Slider */}
        <div className="md:hidden">
          <TestimonialCard t={testimonials[active]} />
          <div className="flex items-center justify-center gap-3 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === active ? 'w-6 h-2 bg-[#C4A45A]' : 'w-2 h-2 bg-[#E0D8CE]'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const TestimonialCard = ({ t }: { t: typeof testimonials[0] }) => (
  <div className="bg-[#FAF7F2] rounded-2xl p-6 flex flex-col">
    {/* Stars */}
    <div className="flex gap-0.5 mb-4">
      {Array.from({ length: t.rating }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#C4A45A] text-sm"></i>
      ))}
    </div>
    {/* Quote */}
    <p className="font-raleway text-[#6B6560] text-sm leading-relaxed flex-1 mb-6">
      "{t.text}"
    </p>
    {/* Author */}
    <div className="flex items-center gap-3">
      <div className="w-11 h-11 flex-shrink-0 rounded-full overflow-hidden">
        <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
      </div>
      <div>
        <p className="font-raleway text-sm font-semibold text-[#2C2B29]">{t.name}</p>
        <p className="font-raleway text-xs text-[#8B8680]">{t.role}</p>
      </div>
    </div>
  </div>
);

export default Testimonials;
